import { useState } from 'react';

const initFacebookSdk = () => {
  // wait for facebook sdk to initialize
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: import.meta.env.VITE_FACEBOOK_APP_ID,
      // cookie: true,
      xfbml: true,
      version: 'v15.0',
    });
  };

  // load facebook sdk script
  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
};

export default function useFacebookLogin() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  try {
    initFacebookSdk();
  } catch (error) {
    setError(true);
  }

  const Login = async () => {
    setLoading(true);
    try {
      await window.FB.login(
        function (response) {
          if (response.status === 'connected') {
            // Logged in Facebook
            setData(response.authResponse);
          } else {
            // not logged or unknown error
            setError(true);
          }
        },
        { scope: 'public_profile,email' }
      );
      setLoading(false);
    } catch {
      setError(true);
      setLoading(false);
    }
  };

  return [Login, data, loading, error];
}
